/**
 * Service Carousel
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="service"></div>
 */
import 'slick-carousel';
$(function () {
  $('[data-component="service"]').each(function () {
    let $holder = $(this);
    $holder.slick({
      rows: 0,
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  });
});